import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./Upload_documents_modal.css";
import File_lottie from "../../../animation/file_lottie/File_lottie";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";

import {
  Create,
  GetAll,
} from "../../../../features/admin/student/add_student_documents/Slice";
import Success_modal from "../success_modal/Success_modal";
import rejectAnimation from "../../../animation/success_lottie/Reject_lottie.json";
import successAnimation from "../../../animation/success_lottie/Success_lottie.json";
import { allStudentDocument } from "../../../../features/admin/common/Slice";
import Blue_border_button from "../../common_btn/blue_border_button/Blue_border_button";
import { IDS } from "../../../../utils/IDS";

function Upload_documents_modal({ ...props }) {
  const StudentDocuments = useSelector(
    (state) => state?.common?.all_student_document
  );

  console.log(StudentDocuments, "StudentDocuments");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    setValue,
    getValues,
    watch,
  } = useForm({});

  const ImageFile = watch("image");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append(
        "student_document_id",
        data?.student_document_id?.value || ""
      );

      if (data?.image && data.image.length > 0) {
        sendData.append("image", data.image[0]);
      }
      const res = await dispatch(Create(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setModalsuccessShow(true);
        reset();

        setTimeout(() => {
          setModalsuccessShow(false);
          props?.onHide();
        }, 3000);
      } else if (res.meta?.requestStatus === "rejected") {
        setShowRejectModal(true);
      }
    } catch (error) {
      setShowRejectModal(true);

      console.error(error);
    }
  };

  useEffect(() => {
    dispatch(allStudentDocument());
  }, [dispatch]);

  const handleDocumentChange = async (selectedOption) => {
    setValue("student_document_id", selectedOption);
  };

  return (
    <Modal
      {...props}
      size="lg"
      centered
      className="upload_docs_modal custom_modal"
    >
      <Modal.Body>
        <h5 className="modal_title">Upload Documents</h5>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <Form.Group className="mb-3">
              <Form.Label>Document</Form.Label>
              <Controller
                name="student_document_id"
                control={control}
                rules={{ required: "Document is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={StudentDocuments}
                    onChange={handleDocumentChange}
                    onInputChange={(val) => {
                      dispatch(allStudentDocument(val));
                    }}
                  />
                )}
              />
              {errors?.student_document_id && (
                <Form.Text className="text-danger">
                  {errors?.student_document_id?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4 mb-3">
            <Form.Group className="form_field"></Form.Group>
            <Form.Label>Logo</Form.Label>
            <Form.Control
              className={classNames("", {
                "is-invalid": errors?.image,
              })}
              type="file"
              {...register("image", {
                required: "ImageFile is required",
                validate: async (value) => {
                  // if (typeof value !== "string") {
                  //   const fileTypes = ["jpg", "png", "jpeg"];
                  //   const fileType = value[0].name?.split(".")[1];
                  //   if (!fileTypes.includes(fileType)) {
                  //     return `please upload a valid file format. (${fileTypes})`;
                  //   }
                  // }
                },
              })}
              accept=".jpg, .jpeg, .png"
            />
            {errors.image && (
              <span className="text-danger">{errors.image.message}</span>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <Form.Group className="mb-3">
              <Form.Label className="text-center">Image Preview</Form.Label>
              {typeof getValues("image") == "string" ? (
                <div className="image-preview-container">
                  <img
                    src={IDS.IMG_URL + getValues("image")}
                    alt="Preview"
                    className="image-preview"
                    style={{ width: "150px", height: "130px" }}
                  />
                </div>
              ) : (
                ImageFile &&
                ImageFile?.length > 0 && (
                  <div className="image-preview-container">
                    <img
                      // src={URL.createObjectURL(getValues("image")[0])}
                      src={URL?.createObjectURL(ImageFile[0])}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "100px", height: "100px" }}
                    />
                  </div>
                )
              )}
            </Form.Group>
          </div>

          <div className="btn_holder">
            {/* <Blue_btn btn_text={"Cancle"} /> */}
            <Blue_border_button button_text={"Save"} type="submit" />
          </div>
        </Form>
      </Modal.Body>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
      <Success_modal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        message_text="Application Rejected"
        animationData={rejectAnimation}
      />
    </Modal>
  );
}

export default Upload_documents_modal;
